import { AlertTriangle, RefreshCw } from "lucide-react";
import { useRouteError } from "react-router-dom";

import { Button } from "@/components/ui/button";

/**
 * Frontière d'erreur globale des routes (React Router `errorElement`).
 *
 * Deux cas couverts, qui donnaient sinon un écran blanc irrécupérable :
 *  - échec de chargement d'un chunk lazy (typique après un déploiement : le
 *    hash des fichiers a changé et l'onglet resté ouvert pointe l'ancien) ;
 *  - erreur de rendu d'une page.
 * Dans les deux cas, on propose un rechargement (qui récupère les nouveaux
 * chunks).
 */
export function RouteErrorBoundary() {
  const error = useRouteError();
  const message = error instanceof Error ? error.message : String(error ?? "");
  const isChunkError =
    /Loading chunk|dynamically imported module|Importing a module script failed|Failed to fetch/i.test(
      message,
    );

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background p-4 text-center">
      <AlertTriangle className="h-10 w-10 text-primary" aria-hidden />
      <h1 className="text-xl font-semibold text-foreground">
        {isChunkError ? "Une nouvelle version est disponible" : "Une erreur est survenue"}
      </h1>
      <p className="max-w-md text-sm text-muted-foreground">
        {isChunkError
          ? "L'application a été mise à jour. Rechargez la page pour continuer."
          : "Le chargement de cette page a échoué. Rechargez pour réessayer ; si le problème persiste, contactez le support."}
      </p>
      <Button onClick={() => window.location.reload()} className="gap-2">
        <RefreshCw className="h-4 w-4" /> Recharger la page
      </Button>
    </div>
  );
}
